import { render, staticRenderFns } from "./Sector.vue?vue&type=template&id=e2686a5a&scoped=true&"
import script from "./Sector.vue?vue&type=script&lang=js&"
export * from "./Sector.vue?vue&type=script&lang=js&"
import style0 from "./Sector.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Sector.vue?vue&type=style&index=1&id=e2686a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2686a5a",
  null
  
)

export default component.exports